/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_custom.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions Custom */
HafasWebapp.prototype.subscriptions.TRM = function (_me) {
  Hafas.ps.sub('/app/updateBanner', Hafas.bind(_me.Controller.TRM.showBanner, _me));
  Hafas.ps.sub('/app/replaceAllBanner', Hafas.bind(_me.Controller.TRM.replaceAll, _me));
  Hafas.ps.sub('/trm/setLocation', Hafas.bind(_me.Controller.TRM.setLocation, _me));
  Hafas.ps.sub('/trm/printData', Hafas.bind(_me.Controller.TRM.printData, _me));
  Hafas.ps.sub('/trm/prepareJourneyPassesThrough', Hafas.bind(_me.Controller.TP.prepareTrmJourney, _me));
  Hafas.ps.sub('/trm/setCluster', Hafas.bind(_me.Controller.TRM.setCluster, _me));
};
